export default __webpack_public_path__ + "static/media/ferit_logo_small.8906d28a.png";